

import {
  Component,
  EventEmitter,
  Input,
  Output,
  ChangeDetectionStrategy
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogConfig } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { VshcDialogModule, ZefScrollModule } from '@vshosting/core';

@Component({
  selector: 'vshc-dialog-wrapper',
  templateUrl: './dialog-wrapper.component.html',
  styleUrls: ['./dialog-wrapper.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    MatButtonModule,
    MatIconModule,
    ZefScrollModule,
    VshcDialogModule
  ]
})
export class VshcDialogWrapperComponent {

  @Input()
  open: boolean;

  @Input()
  heading: string;

  @Input()
  description: string;

  #options: MatDialogConfig;
  @Input()
  set options(v: MatDialogConfig) {
    this.#options = v ?? {};

    const panelClasses = [
      ...(Array.isArray(v.panelClass)
        ? v.panelClass
        : v.panelClass
          ? [v.panelClass]
          : []),
      'c-dialog-no-padding',
    ];

    this.#options = {
      ...this.options,
      ...{
        panelClass: panelClasses,
        maxWidth: '95vw',
        restoreFocus: false
      }
    };
  }
  get options(): MatDialogConfig {
    return this.#options;
  }

  @Input()
  disableCloseButton = false;

  @Output()
  closeTrigger = new EventEmitter();

}
